import { makeStyles } from 'tss-react/mui'
import { getDirectionValue, getMobileSpacingTop, getMobileSpacingBottom } from '@v4/utils/theme'

const useStyles = makeStyles()((theme, { metaData, mobileDirection, minMargins }) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	background: {
		display: 'none',
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		maxWidth: '100%',
		overflow: 'hidden',
		backgroundPositionY: metaData.backgroundImagePosition?.metaValue,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		'&:after': {
			content: '""',
			transition: theme.transitions.create('opacity'),
			backgroundColor: 'black',
			width: '100%',
			height: '100%',
			position: 'absolute',
			top: 0,
			left: 0,
			opacity: metaData.opacity?.toNumber() / 100,
		},
	},
	bgMobile: {
		[theme.breakpoints.down('md')]: {
			display: 'block',
		},
	},
	bgDesktop: {
		[theme.breakpoints.up('md')]: {
			display: 'block',
		},
	},
	grid: {
		zIndex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',

		[theme.breakpoints.down('md')]: {
			order: getDirectionValue(mobileDirection, { desc: 2 }),
		},
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'stretch',
		transition: theme.transitions.create(['padding-top', 'padding-bottom']),

		[theme.breakpoints.down('md')]: {
			paddingTop: getMobileSpacingTop({
				metaData,
				minMargins,
				theme,
				disabled: !metaData.mobileImagePosition?.isLeftAlignment,
			}),
			paddingBottom: getMobileSpacingBottom({
				metaData,
				minMargins,
				theme,
				disabled: !metaData.mobileImagePosition?.isRightAlignment,
			}),
		},
	},

	mobileImage: {
		display: 'none',
		[theme.breakpoints.down('md')]: {
			display: 'block',
			order: getDirectionValue(mobileDirection, { desc: 1 }, 2),
		},
	},

	image: {
		'& picture': {
			display: 'flex',
			justifyContent: 'center',
		},
		'& img': {
			objectPosition: 'center',
			objectFit: 'contain',
		},
	},

	buttonWrap: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',

		[theme.breakpoints.down('sm')]: {
			justifyContent: metaData.mobileAlignment?.contentAlignment(),
		},
	},

	button: {
		width: 'auto',
		marginRight: theme.spacing(1),

		[theme.breakpoints.down('sm')]: {
			marginBottom: theme.spacing(2),

			width: metaData.mobileButtonWidth?.isWide ? '100%' : 'auto',
		},
	},
	text: {
		textAlign: 'center',
		marginBottom: theme.spacing(5),

		[theme.breakpoints.down('sm')]: {
			textAlign: metaData.mobileAlignment?.metaValue,
		},
	},
}))

export default useStyles
